import { GetPolicyDraftResponseType } from '@clearcover/core-app-types';

export function draftEndpointModifier(
  draftType: GetPolicyDraftResponseType['policyDraft']['draftType'] | undefined,
  renewalQuotesEnabled: boolean
): string {
  switch (draftType) {
    case 'renewal':
      return renewalQuotesEnabled ? '/renewalQuote' : '/renewal';
    case 'renewal_quote':
      return '/renewalQuote';
    default:
      return '';
  }
}
